import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthenicationService } from '../../_services/authenication.service';
import { UserService } from '../../_services/user.service';
import {ActivatedRoute, Router} from '@angular/router';
import * as jwt_decode from 'jwt-decode';

import { ToasterService } from '../../_services/toaster.service';

@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.css']
})
export class ForgotpasswordComponent implements OnInit {

  forgotForm: FormGroup;
  submitted = false;
  returnUrl: string;
  alert: string;

  // tslint:disable-next-line:max-line-length
  constructor(private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute, private authenicationService: AuthenicationService, private toaster: ToasterService, private userservice: UserService) { }

  ngOnInit() {
    // DynamicScriptLoaderServiceService.adminScripts();
    if (this.authenicationService.currentUserValue) {
      this.router.navigate(['/']);
    }

    this.forgotForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });

    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';


  }


  get f() { return this.forgotForm.controls; }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.forgotForm.invalid) {
      return;
    }

    const loginPayload = {
      email: this.forgotForm.controls.email.value,
      user_type:'internal'
    };

    this.userservice.resetPassword(loginPayload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            //this.toaster.showSuccess('Forgot Password', data.ResponseMessage);
            setTimeout(() => {
             this.router.navigate(['login']);
            }, 1000);  // 5s
            // location.reload();
          } else {
            this.toaster.showError('Forgot Password', data.ResponseMessage);
          }
        },
        error => {
          this.submitted = false;
          this.toaster.showError('Forgot Password', error.error.ResponseMessage);
        });
  }

}
